import React, { Suspense } from 'react';
import { PREDEFINE_ICON1, PREDEFINE_ICON2 } from '../../common/images-s3';
const ImageLoader = React.lazy(() => import('../../common/image-loader'));

const PredefinedQuestions = ({ predefinedQuestions, setInput, onSendMessage, isSending }) => {
    return (
        <div className="predefined-ques">
            {(predefinedQuestions || []).map((question, index) => (
                <button
                    key={index}
                    onClick={() => {
                        setInput(question);
                        onSendMessage(question);
                    }}
                    disabled={isSending}
                    className={`predefined-buttons ${isSending ? 'cursor-not-allowed' : ''}`}
                >
                    <Suspense fallback={null}>
                        <ImageLoader
                            type="image"
                            src={question.toLowerCase().includes("individual") ? PREDEFINE_ICON1 : question.toLowerCase().includes('business') ? PREDEFINE_ICON2 : null}
                        />
                    </Suspense>
                    {question}
                </button>
            ))}
        </div>
    );
};

export default PredefinedQuestions;